import { render, staticRenderFns } from "./ShipmentPackage.vue?vue&type=template&id=51e8a1f1&scoped=true"
import script from "./ShipmentPackage.vue?vue&type=script&lang=js"
export * from "./ShipmentPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8a1f1",
  null
  
)

export default component.exports